<template>
    <explanation-hiding-description
        :appliedHidings="appliedTryoutQuestionHidings"
    ></explanation-hiding-description>
</template>

<script>
import ExplanationHidingDescription from './ExplanationHiidngDescription.vue'

export default {
    props: {
        hidings: {
            type: Array,
            required: true
        },
        explanation: {
            type: Object,
            required: true
        }
    },

    components: {
        ExplanationHidingDescription,
    },

    computed: {
        appliedTryoutQuestionHidings() {
            return this.hidings
                .filter(hiding => this.explanation.hidings.includes(hiding.id))
        }
    }
}
</script>
